import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import CardMedia from '@material-ui/core/CardMedia';

import { bonus }  from './__data';

const url = `
url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25' height='100%25' %3E%3Cdefs%3E%3ClinearGradient id='a' x1='0' x2='0' y1='0' y2='1'%3E%3Cstop offset='0' stop-color='%23000000'/%3E%3Cstop offset='1' stop-color='%23000000'/%3E%3C/linearGradient%3E%3C/defs%3E%3Cpattern id='b' width='4' height='4' patternUnits='userSpaceOnUse'%3E%3Ccircle fill='%23ffffff' cx='2' cy='2' r='2'/%3E%3C/pattern%3E%3Crect width='100%25' height='100%25' fill='url(%23a)'/%3E%3Crect width='100%25' height='100%25' fill='url(%23b)' fill-opacity='0.1'/%3E%3C/svg%3E");
`;


const useStyles = makeStyles((theme) => ({
  paper: {
    height: '100%',
    padding: theme.spacing(4),
    background: 'transparent',
    boxShadow: 'none',
  },
  section: {
    padding: '5rem 0',
    borderTop: '3px dotted white',
    borderBottom: '3px dotted white',
    backgroundColor: '#000000',
    backgroundImage: url,
    backgroundAttachment: 'fixed',
    backgroundSize: 'cover',
  },
  text: {
    color: 'white'
  },
}));

export default function ImageGridList() {
  const classes = useStyles();

  return (
    <Grid
      className={classes.section}
      component="article"
      container
    >
      <Grid
        item
        xs={12}
      >
        <Paper
          className={classes.paper}
          elevation={0}
        >
          <Typography
            align="center"
            component="h2"
            style={{color: 'white'}}
            variant="h1"
          >
            Team & MeetUP
          </Typography>
          <Typography
            align="center"
            component="p"
            style={{color: 'white'}}
            variant="body2"
          >
            Les photos de l'incubateur&nbsp;
            <a
              href="https://www.prism.pf"
              style={{color: '#1395FF', fontWeight: '500'}}
              target="_blank"
            >PRISM</a> , de l'équipe&nbsp;
            <a
              href="https://www.facebook.com/Ecolepoly3d"
              style={{color: '#dd3d85', fontWeight: 500}}
              target="_blank"
            >
              POLY 3D</a> mais aussi des premières pousses effectués aux prémisses de SeedOut Fenua.
          </Typography>
        </Paper>
      </Grid>
      <Paper
        className={classes.paper}
        elevation={0}
      >
        <Grid
          className={classes.gridList}
          cols={6}
          container
          spacing={3}
        >
          <Grid
            item
            md={6}
            xs={12}
          >
            <CardMedia
              alt={bonus[0].alt}
              component="img"
              image={bonus[0].img}
              style={{height: '25rem'}}
              title={bonus[0].title}
            />
          </Grid>
          <Grid
            item
            md={6}
            xs={12}
          >
            <CardMedia
              alt={bonus[1].alt}
              component="img"
              image={bonus[1].img}
              style={{height: '25rem'}}
              title={bonus[1].title}
            />
          </Grid>
          <Grid
            item
            md={8}
            xs={12}
          >
            <CardMedia
              alt={bonus[2].alt}
              component="img"
              image={bonus[2].img}
              style={{height: '25rem'}}
              title={bonus[2].title}
            />
          </Grid>
          <Grid
            item
            md={4}
            xs={12}
          >
            <CardMedia
              alt={bonus[3].alt}
              component="img"
              image={bonus[3].img}
              style={{height: '25rem'}}
              title={bonus[3].title}
            />
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
}
